import { gql } from '@apollo/client';

export const INVOICE_FRAGMENT = gql`
    fragment InvoiceFragment on Invoice {
        id
        invoiceId
        status
        type
        amount
        tax
        subtotal
        taxTotal
        discountAmount
        discountPercent
        discountDescription
        dueDate
        issueDate
        headerNotes
        footerNotes
        internalNotes
        sentAt
        paidAt
        cancelledAt
        cancellationReason
        isEditable
        calculatedDiscount
        lineCount
        createdAt
        updatedAt
        document {
            url
        }
        member {
            id
            firstName
            lastName
            email
        }
        company {
            id
            name
        }
        createdBy {
            id
            firstName
            lastName
        }
        approvedBy {
            id
            firstName
            lastName
        }
    }
`;

export const INVOICE_LINE_FRAGMENT = gql`
    fragment InvoiceLineFragment on InvoiceLine {
        id
        sortOrder
        description
        quantity
        unitPrice
        discountPercent
        discountAmount
        taxRate
        taxAmount
        lineTotal
        source
        sourceReference
        createdAt
    }
`;

export const INVOICES = gql`
    ${INVOICE_FRAGMENT}
    query Invoices(
        $first: Int
        $offset: Int
        $search: String
        $sort: InvoiceSortEnum
        $member: ID
        $company: ID
        $status: InvoiceStatus
        $status_In: [InvoiceStatus]
        $type: InvoiceType
        $type_In: [InvoiceType]
        $dateFrom: Date
        $dateTo: Date
    ) {
        invoices(
            first: $first
            offset: $offset
            search: $search
            sort: $sort
            member: $member
            company: $company
            status: $status
            status_In: $status_In
            type: $type
            type_In: $type_In
            dateFrom: $dateFrom
            dateTo: $dateTo
        ) {
            totalCount
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            edges {
                node {
                    ...InvoiceFragment
                }
            }
        }
    }
`;

export const INVOICE = gql`
    ${INVOICE_FRAGMENT}
    ${INVOICE_LINE_FRAGMENT}
    query Invoice($id: ID!) {
        invoice(id: $id) {
            ...InvoiceFragment
            lines {
                ...InvoiceLineFragment
            }
        }
    }
`;

export const INVOICE_STATS = gql`
    query InvoiceStats {
        invoiceStats {
            totalCount
            draftCount
            pendingApprovalCount
            sentCount
            paidCount
            overdueCount
            cancelledCount
            totalAmount
            paidAmount
            outstandingAmount
        }
    }
`;
